var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "actions/download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4002 17.3349L13.4002 4.15938C13.4002 3.71755 13.7584 3.35938 14.2002 3.35938C14.642 3.35938 15.0002 3.71755 15.0002 4.15938V16.9595L19.6762 12.5722C19.994 12.274 20.492 12.2913 20.7885 12.6107C21.0851 12.9301 21.0679 13.4308 20.7502 13.7289L14.5372 19.5584C14.2348 19.8421 13.7656 19.8421 13.4632 19.5584L7.2502 13.7289C6.93245 13.4308 6.91528 12.9301 7.21184 12.6107C7.5084 12.2913 8.0064 12.274 8.32414 12.5722L13.4002 17.3349ZM4.0002 19.5593C4.44202 19.5593 4.8002 19.9175 4.8002 20.3593V24.3593C4.8002 24.4698 4.88974 24.5593 5.0002 24.5593H23.0002C23.1107 24.5593 23.2002 24.4698 23.2002 24.3593V20.3593C23.2002 19.9175 23.5584 19.5593 24.0002 19.5593C24.442 19.5593 24.8002 19.9175 24.8002 20.3593V24.3593C24.8002 25.3534 23.9943 26.1593 23.0002 26.1593H5.0002C4.00608 26.1593 3.2002 25.3534 3.2002 24.3593V20.3593C3.2002 19.9175 3.55837 19.5593 4.0002 19.5593Z",
    fill: "#005FC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.ca5d66cd.svg";
export { ForwardRef as ReactComponent };